'use strict';

const PROJECTILE_NAMES = [
  '星能胡萝卜', '量子毛线球', '回旋飞骨', '幽蓝狐火', '极光冰晶',
  '新月狼牙', '蜂蜜能量罐', '暴风雪球', '翠竹飞梭', '枫叶旋刃',
  '虎纹光爪', '烈阳狮鬃', '斑纹光弹', '疾风电矢', '猞猁冰刃',
  '幻影面具', '水獭浪珠', '河狸木轮', '仓鼠瓜子', '豚鼠豌豆',
  '松鼠橡果', '龙猫云团', '刺猬尖刺', '考拉桉叶', '袋鼠拳套',
  '袋熊岩球', '树懒藤蔓', '水豚泡泡', '狐獴飞镖', '鼹鼠土钻',
  '猴子桃核', '猩猩重拳', '红猩火种', '象牙飞梭', '长颈星斑',
  '斑马条纹刃', '犀牛光角', '河马水波', '骏马蹄铁', '飞驴铜铃',
  '奶牛乳滴', '山羊弯角', '绵羊毛球', '小猪鼻泡', '羊驼绒弹',
  '美洲驼流苏', '梅花花瓣', '驼鹿巨角', '驯鹿雪花', '骆驼沙晶',
  '牦牛冰角', '水牛涡珠', '野牛盾轮', '羚羊月角', '瞪羚光矢',
  '海豹冰泡', '海狮声波', '海豚珍珠', '鲸鱼水柱', '虎鲸音环',
  '鲨鱼利齿', '蝠鲼翼刃', '章鱼墨滴', '鱿鱼触须', '螃蟹钳光',
  '龙虾甲片', '海马珍珠', '企鹅雪球', '猫头鹰羽刃', '老鹰雷羽',
  '猎鹰风镖', '鹦鹉彩羽', '火烈鸟火羽', '孔雀眼翎', '天鹅白羽',
  '鸭子水滴', '大鹅飞羽', '小鸡星蛋', '火鸡玉米', '鸵鸟疾羽',
  '几维果籽', '鳄鱼尖牙', '海龟旋壳', '变色龙幻眼', '壁虎吸盘',
  '鬣蜥鳞叶', '小蛇毒牙', '青蛙水珠', '六角恐龙泡泡', '蝴蝶光翼',
  '蜜蜂毒针', '瓢虫星点', '甲虫甲壳', '蜻蜓风翼', '螳螂双刃',
  '蜗牛螺旋', '蝙蝠音波', '鸭嘴兽电盘', '臭鼬烟雾团'
];

const RENDERERS = [
  'carrot', 'orb', 'bone', 'flame', 'crystal', 'crescent', 'jar', 'snowflake', 'leaf', 'blade',
  'claw', 'star', 'orb', 'dart', 'blade', 'disc', 'droplet', 'disc', 'seed', 'orb',
  'seed', 'cloud', 'spike', 'leaf', 'orb', 'orb', 'leaf', 'bubble', 'dart', 'spike',
  'seed', 'orb', 'flame', 'spike', 'star', 'blade', 'horn', 'droplet', 'crescent', 'orb',
  'droplet', 'horn', 'cloud', 'bubble', 'cloud', 'dart', 'leaf', 'horn', 'snowflake', 'crystal',
  'horn', 'orb', 'disc', 'horn', 'dart', 'bubble', 'ring', 'orb', 'droplet', 'ring',
  'tooth', 'blade', 'droplet', 'blade', 'claw', 'shell', 'orb', 'snowflake', 'feather', 'dart',
  'dart', 'feather', 'flame', 'disc', 'feather', 'droplet', 'feather', 'egg', 'seed', 'feather',
  'seed', 'tooth', 'shell', 'disc', 'disc', 'leaf', 'tooth', 'droplet', 'bubble', 'feather',
  'dart', 'disc', 'shell', 'feather', 'blade', 'spiral', 'ring', 'disc', 'cloud'
];

const MOTIONS = Object.freeze([
  'straight', 'wave', 'boomerang', 'zigzag', 'accelerate', 'arc',
  'homing', 'spiral', 'drift', 'split', 'pulse'
]);

function profileForIndex(index) {
  const level = index + 1;
  const motionKey = MOTIONS[index % MOTIONS.length];
  const hue = (index * 47 + 12) % 360;
  const secondaryHue = (hue + 72 + (index % 4) * 18) % 360;
  return Object.freeze({
    level,
    projectileName: PROJECTILE_NAMES[index],
    rendererKey: RENDERERS[index],
    primaryColor: `hsl(${hue} 92% 62%)`,
    secondaryColor: `hsl(${secondaryHue} 96% 76%)`,
    scale: Number((0.78 + (index % 7) * 0.07).toFixed(2)),
    radius: 9 + (index % 5),
    rotationSpeed: Number((((index % 2 ? -1 : 1) * (1.2 + (index % 6) * 0.46))).toFixed(2)),
    speedMultiplier: Number((0.78 + (index % 9) * 0.035).toFixed(3)),
    motionKey,
    amplitude: 28 + (index % 8) * 7,
    frequency: Number((2.1 + (index % 7) * 0.38).toFixed(2)),
    turnRate: Number((0.72 + (index % 8) * 0.12).toFixed(2)),
    acceleration: 16 + (index % 9) * 7,
    curveRate: Number((((index % 2 ? -1 : 1) * (0.28 + (index % 7) * 0.07))).toFixed(2)),
    turnAfter: Number((0.42 + (index % 6) * 0.09).toFixed(2)),
    splitAfter: motionKey === 'split' ? Number((0.58 + (index % 5) * 0.08).toFixed(2)) : 0,
    splitCount: motionKey === 'split' ? 3 + (index % 4) : 0,
    spreadModifier: Number((0.82 + (index % 6) * 0.07).toFixed(2)),
    burstModifier: Number((0.86 + (index % 5) * 0.06).toFixed(2)),
    variant: index % 12
  });
}

if (PROJECTILE_NAMES.length !== 99 || RENDERERS.length !== 99) {
  throw new Error('Boss projectile catalog must contain exactly 99 entries.');
}

const BOSS_PROJECTILE_PROFILES = Object.freeze(PROJECTILE_NAMES.map((_, index) => profileForIndex(index)));

function getBossProjectileProfile(level) {
  const safeLevel = Math.max(1, Math.min(99, Math.floor(Number(level) || 1)));
  return BOSS_PROJECTILE_PROFILES[safeLevel - 1];
}

module.exports = { BOSS_PROJECTILE_PROFILES, getBossProjectileProfile };
